import React from 'react';
import { OverviewRisk } from '../types';
import RiskBadge from './RiskBadge';
import { riskColours } from '../utils/riskUtils';

/** Show controlled status distinctly from a hazard or incident rating. */
export default function CurrentRiskBadge({risk}: {risk?: OverviewRisk | null}) {
  if (risk?.reason === 'Under control') return <span style={{...riskColours.low,borderRadius:6,padding:'3px 8px'}}>Under control</span>;
  return <span><RiskBadge likelihood={risk ? {A:5,B:4,C:3,D:2,E:1}[risk.code[0]] : undefined} consequence={risk ? Number(risk.code.slice(1)) : undefined}/>{risk?.reason && <small style={{display:'block'}}>{risk.reason}</small>}</span>;
}
